export default __webpack_public_path__ + "static/media/Copy of 96cm_blue.98c42fe2.mp4";